var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdownIndicator = function SvgDropdownIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#8C9AAB",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.738 5.505a.7.7 0 0 1 0 .99l-4.243 4.243a.7.7 0 0 1-.99 0L3.262 6.495a.7.7 0 1 1 .99-.99L8 9.253l3.748-3.748a.7.7 0 0 1 .99 0Z"
  })));
};
export default SvgDropdownIndicator;